export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED'
export const SET_MEMBERSHIP_CONFIG = 'SET_MEMBERSHIP_CONFIG' 
export const ADD_CUSTOMER_LINKS = 'ADD_CUSTOMER_LINKS'